export default __webpack_public_path__ + "static/media/LFSKS.logotipas-1024x738.bb32572d.png";